// @flow
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import Modal from '~/components/widgets/modal';
import { findDeviceTypeMessage } from '~/core/translations/devices';
import messages from '~/core/i18n/components/widgets/remove-device/intl';
import { RemoveButton } from './styles';
import { categories } from '~/core/components/widgets/remove-device/constants';
import Connector from '~/core/components/widgets/remove-device/redux';
import { mapCategoryToHeading } from '~/core/components/widgets/remove-device/';

type State = {
    showRemoveModal: boolean
};

type Props = {
    deviceCategory: string,
    deviceName: string,
    manufacturer: string,
    remove: () => any,
    type: string
};

const mapCategoryToText = (category, type, device, manufacturer) => {
    const textMap = new Map([
        [category === categories.HUE, <FormattedMessage key="remove-hue-text" {...messages.removeHueText} />],
        [
            category === categories.ZONE,
            <FormattedMessage key="remove-zone-text" values={{ device }} {...messages.cancelOrConfirmZone} />
        ],
        [
            category === categories.DEVICE,
            <span key="remove-device-text">
                <FormattedMessage {...messages.cancelOrConfirm} values={{ device }} />&nbsp;
                <FormattedMessage
                    id="devicetype"
                    {...findDeviceTypeMessage(type, manufacturer)}
                    values={{ amount: 1 }}
                />
            </span>
        ]
    ]);
    return textMap.get(true);
};

class RemoveDeviceComponent extends Component<Props, State> {
    state = {
        showRemoveModal: false
    };

    showRemoveModal = (e: SyntheticInputEvent<>) => {
        e.preventDefault();
        this.setState({ showRemoveModal: true });
    };

    hideRemoveModal = () => {
        this.setState({ showRemoveModal: false });
    };

    remove = () => {
        this.hideRemoveModal();
        this.props.remove();
    };

    render() {
        const { deviceName, type, deviceCategory, manufacturer } = this.props;

        const { showRemoveModal } = this.state;

        const deviceSpecificHeading = mapCategoryToHeading(deviceCategory);
        return [
            <Modal
                contentLabel="Remove Device Modal"
                isOpen={showRemoveModal}
                key="remove-device-modal"
                onRequestClose={this.hideRemoveModal}
                onSave={this.remove}
                saveText={deviceSpecificHeading}
            >
                <h2>
                    <FormattedMessage {...deviceSpecificHeading} />?
                </h2>
                <p>{mapCategoryToText(deviceCategory, type, deviceName, manufacturer)}</p>
            </Modal>,

            <RemoveButton alternate key="remove-device-button" onClick={this.showRemoveModal}>
                <FormattedMessage {...deviceSpecificHeading} />
            </RemoveButton>
        ];
    }
}

const RemoveDevice = (props: *) => <Connector {...props} render={props => <RemoveDeviceComponent {...props} />} />;
export default RemoveDevice;



// WEBPACK FOOTER //
// ./src/components/widgets/remove-device/index.js